// extracted by mini-css-extract-plugin
export var smallCard = "SmallCard-module--smallCard--3ThKx";
export var smallCardMain = "SmallCard-module--smallCardMain--rBG7A";
export var dark = "SmallCard-module--dark--9ldm8";
export var light = "SmallCard-module--light--3gjHc";